import { Dispatch, MouseEventHandler, ReactElement, SetStateAction } from 'react';

import { IconSvgProps } from '@/lib/v2/components';
import { Option } from '@/lib/v2/components/Select/Select';

export type ActionTypeName =
  | 'email'
  | 'email-trigger'
  | 'sms'
  | 'email-attachment'
  | 'mail-api'
  | 'sms-api';
export type ActionTypeId = 1 | 3 | 8 | 9 | 4 | 5;

//TODO: Update naming convention
export interface IChildProps {
  children: React.ReactElement;
}

export type TCampaignID = number;

export interface ICampaign {
  campaignId: TCampaignID;
  name: string;
  strategy: string | null;
  strategyId: number | null;
  state: number;
  creationDate: string;
  lastUpdate: string;
  duration: number;
  audience: string | number | null;
  actions: number;
  campaignTypeId: ECampaignsTypeOptions;
}

export interface ITotalsCampaign {
  total: number;
  partial: number;
}

interface ICreatorUser {
  email: string;
  id: number;
  lastName: string;
  name: string;
}

export interface ICampaignDetail {
  name?: string;
  goal?: string | undefined;
  strategyName?: string | undefined;
  state?: number;
  creatorUser?: ICreatorUser;
  startDate?: string;
  endDate?: string;
  campaignId?: TCampaignID;
  campaignTypeId?: number;
}

export interface ICampaignDetailV1 {
  campaign: {
    id: number;
    name: string;
  };
  action?: {
    id: number;
    name: string;
  };
}

export interface ICampaignDetailResponse {
  statusOK?: boolean;
  campaign: ICampaignDetail;
}

export interface ICampaignDetailResult {
  result: ICampaignDetail[];
}

export interface IStrategy {
  strategyId: number;
  name: string;
}
export interface IStrategyDropdown {
  id: number;
  label: string;
  value: number;
}
export interface ICampaignInfoMain {
  count: number;
  loading: boolean;
}

export interface ITableCampaigns {
  campaign: ICampaign;
}
export interface ICampaignsListResponse {
  statusOK?: boolean;
  campaigns?: ITableCampaigns[];
  total?: number;
  partial?: number;
}

export interface ICampaignsStrategiesResponse {
  statusOK?: boolean;
  strategies?: IStrategy[];
}

export enum EStrategyOptionsName {
  MARKETING = 'Marketing',
  SALES = 'Sales',
  REMARKETING = 'Remarketing',
  NURTURING = 'Nurturing',
  LEAD_GENERATION = 'Lead-generation',
  LEAD_RECOVERY = 'Lead-recovery',
  CROSS_SELLING = 'Cross-selling',
  UP_SELLING = 'Up-selling',
  LAUNCH = 'Launch',
}

export enum EStates {
  ACTIVE = 1,
  INACTIVE = 0,
}

export interface IStateOption {
  id: number;
  label: string;
  value: string;
}

export enum ECampaignsTypeOptions {
  MANUAL = 1,
  AUTOMATIC = 2,
}

export enum EMaxMinLength {
  MIN_LENGTH = 2,
  NAME_MAX = 60,
  OBJECTIVE_MAX = 150,
  OTHER_STRATEGY_MAX = 30,
}

export enum EChannelsID {
  EMAIL = 1,
  SMS = 8,
  EMAIL_TRIGGER = 3,
  EMAIL_ATTACHMENT = 9,
  EMAIL_API = 4,
  SMS_API = 5,
}

export interface IFormInput {
  name: string;
  type: number;
  objective: string;
  strategy: Option | Option[];
  otherStrategy: string;
  date: Date[];
}

export interface IFormAction {
  name: string;
}

export interface ICreateEditCampaigns {
  id?: number;
  name: string;
  campaignStatesId: number;
  deletionDate?: Date | undefined;
  campaignTypeId: number;
  flowId: number | null;
  autoConfirmation: number;
  notifyGroupId: number;
  strategyId: number | null;
  strategyName: string;
  goal: string;
  startDate: Date;
  endDate: Date;
}

export interface ICreateEditCampaignsResponse {
  statusOK: boolean;
}

export interface ICampaignsInfo {
  count: number | undefined;
  loading: boolean;
  total: number;
  partial: number;
}

export interface IOrderByCell {
  id: string;
  isAsc: boolean | undefined;
}

export interface ICampaignListPayload {
  page?: number;
  limit?: number;
  search?: string;
  state?: number[];
  strategy?: number[];
  startDate?: Date;
  endDate?: Date;
  sortField?: string;
  sortOrder?: string;
}

export interface IOrderByTable {
  sortField: string;
  sortOrder: string;
}

export interface IFilterByTable {
  search?: string;
  state?: number[];
  strategy?: number[];
  startDate?: Date;
  endDate?: Date;
}

export interface IActionIcon {
  id: string;
  icon: ReactElement<IconSvgProps>;
  tooltip?: string;
  hide?: boolean;
  onClick: MouseEventHandler<HTMLButtonElement> | undefined;
}

export interface ICampaignsListInfo extends ICampaignsInfo {
  list: ITableCampaigns[];
  reFetchData: () => void;
}

export enum ModalType {
  EDIT = 'edit',
  CREATE = 'create',
  DUPLICATE = 'duplicate',
}

export enum ScreenType {
  MAIN = 'main',
  DETAIL = 'detail',
}

export interface IMutationContext {
  changeTablePage: ({ pageSize, pageIndex }: { pageSize: number; pageIndex: number }) => void;
  resetPagination: () => void;
  setOrderBy: (orderBy: IOrderByTable) => void;
  setFilterBy: Dispatch<SetStateAction<IFilterByTable>>;
  setClearFilterBy: Dispatch<SetStateAction<boolean>>;
}

export interface IStateContext {
  pageSize: number;
  pageIndex: number;
  totalPages: number;
  gotoPageIndex: number;
  filterBy: IFilterByTable;
  clearFilterBy: boolean;
  orderBy: IOrderByTable;
}

export interface ChannelInfo {
  icon: ReactElement<IconSvgProps>;
  route: string;
}

export interface ICampaignDropdown {
  id: number;
  label: string;
  value: number;
}

/** cspell:disable */
export interface IMoveCampaignPayload {
  campaniaId: TCampaignID;
  elementosId: number[];
}
/** cspell:enable */
